import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UIOrgUnitDetail } from '@types'

interface AdminTeamState {
  orgs: UIOrgUnitDetail[]
  isLoading: boolean
  error: null
}

const initialState: AdminTeamState = {
  orgs: [],
  isLoading: false,
  error: null
}

const slice = createSlice({
  name: 'admin-org-details',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },

    // GET Purpose Types
    getAllAdminOrgDetails(state, action: PayloadAction<UIOrgUnitDetail[]>) {
      state.isLoading = false
      state.orgs = action.payload
      state.error = null
    },
    appendAdminOrgDetails(state, action: PayloadAction<UIOrgUnitDetail[]>) {
      state.isLoading = false
      const newOrgs = Array.isArray(action.payload) ? action.payload : [action.payload]
      state.orgs = [...(state.orgs || []), ...newOrgs] // Append new details

      state.error = null
    },
    editAdminOrgDetails(
      state,
      action: PayloadAction<{ individualIdentifier: string; commonName: string }>
    ) {
      state.isLoading = false
      state.orgs = state.orgs.map((org) =>
        org.businessUnitIdentifier === action.payload.individualIdentifier
          ? {
              ...org,
              commonName: action.payload.commonName // Update commonName only
            }
          : org
      )

      state.error = null
    },
    clearAllAdminOrgDetails(state) {
      state.isLoading = false
      state.orgs = []
      state.error = null
    }
  }
})

// Reducer
export const {
  getAllAdminOrgDetails,
  hasError,
  startLoading,
  clearAllAdminOrgDetails,
  appendAdminOrgDetails,
  editAdminOrgDetails
} = slice.actions
export default slice.reducer
